import { Link } from "react-router-dom";
import { Monitor } from "lucide-react";
import Container from "./Container";

const Footer = () => (
  <footer className="border-t border-border bg-card">
    <Container className="py-12">
      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <Link to="/" className="flex items-center gap-2 font-display text-lg font-bold text-foreground">
            <Monitor className="h-5 w-5 text-primary" />
            Responsivly
          </Link>
          <p className="mt-3 text-sm text-muted-foreground">
            Free responsive website testing tool. Check how your site looks on desktop, laptop, tablet, and mobile — instantly.
          </p>
        </div>

        <nav aria-label="Product links">
          <h4 className="mb-3 text-sm font-semibold text-foreground">Product</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/test" className="hover:text-primary transition-colors">Test a Site</Link></li>
            <li><Link to="/features" className="hover:text-primary transition-colors">Features</Link></li>
            <li><Link to="/features#checks" className="hover:text-primary transition-colors">Responsive Checks</Link></li>
            <li><Link to="/faq" className="hover:text-primary transition-colors">FAQ</Link></li>
          </ul>
        </nav>

        <nav aria-label="Use cases">
          <h4 className="mb-3 text-sm font-semibold text-foreground">Use Cases</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/features" className="hover:text-primary transition-colors">Mobile Friendliness Testing</Link></li>
            <li><Link to="/features" className="hover:text-primary transition-colors">Tablet Responsiveness</Link></li>
            <li><Link to="/features" className="hover:text-primary transition-colors">Desktop Layout Audit</Link></li>
            <li><Link to="/features" className="hover:text-primary transition-colors">Responsive Website Audit</Link></li>
          </ul>
        </nav>

        <div>
          <nav aria-label="Company links">
            <h4 className="mb-3 text-sm font-semibold text-foreground">Company</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/about" className="hover:text-primary transition-colors">About</Link></li>
              <li><Link to="/contact" className="hover:text-primary transition-colors">Contact</Link></li>
            </ul>
          </nav>
          <div className="mt-6">
            <h4 className="mb-3 text-sm font-semibold text-foreground">Legal</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><span className="cursor-default">Privacy Policy</span></li>
              <li><span className="cursor-default">Terms of Service</span></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="mt-10 border-t border-border pt-6 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} Responsivly. All rights reserved.
      </div>
    </Container>
  </footer>
);

export default Footer;
